"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const fixPrecision_1 = __importDefault(require("./fixPrecision"));
const sortOrderModifiers_1 = require("./sortOrderModifiers");
const precisionMath_1 = require("./precisionMath");
const round_1 = __importDefault(require("./round"));
function calculateLocalBatchItem(item, order) {
    var _a;
    // 菜單上的固定的 menu discount
    let totalMenuDiscount = item.discount;
    // 選項價格
    const optionsTotal = lodash_1.default.sumBy(item.options, option => (0, precisionMath_1.multiply)(option.price, option.quantity));
    // 餐點的價格 (已扣除菜單上固定的 menu discount)
    const priceDeductDiscount = (_a = item.priceDeductDiscount) !== null && _a !== void 0 ? _a : (0, precisionMath_1.subtract)(item.price, item.discount);
    // 餐點的基本價格 = 餐點價格 + 選項價格
    let originalTotal = (0, precisionMath_1.add)(priceDeductDiscount, optionsTotal);
    // 計算 modifiers
    let totalModifiersDiscount = 0; // 統計全部折扣 (包含 MERCHANT, COMBORULE, DISCOUNT)
    let totalDiscountModifiersDiscount = 0; // 統計全部折扣 (只包含 DISCOUNT)
    let totalMerchantModifiersDiscount = 0; // 統計全部折扣 (只包含 MERCHANT, COMBORULE)
    let total = originalTotal; // 折扣後的金額 (計算 modifiers 時也是剩餘可折扣金額)
    // 尋找是否有改價 (MERCHANT modifier 為改價)
    const hasMerchantModifier = item.modifiers.some(modifier => modifier.type === 'MERCHANT' && modifier.deletedAt == null);
    const modifiers = (0, sortOrderModifiers_1.sortOrderModifiers)(item.modifiers)
        .map(modifier => {
        if (modifier.deletedAt != null) {
            return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
        }
        if (modifier.type === 'COMBORULE' && hasMerchantModifier) {
            return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
        }
        // 計算折扣後的 total (計算結果不可 < 0)
        const totalAfterModifier = Math.max(0, (0, precisionMath_1.add)((0, precisionMath_1.multiply)(total, (0, precisionMath_1.divide)((0, precisionMath_1.add)(100, Number(modifier.percent)), 100)), Number(modifier.amount)));
        // 計算折了多少錢 (計算結果不可 > 可折扣金額)
        let discountValue = Math.min(total, (0, precisionMath_1.subtract)(total, totalAfterModifier));
        if (order.enableIntermediateRounding) {
            discountValue = (0, round_1.default)(discountValue, order.rounding.type, order.rounding.digits);
        }
        // 折扣記入總折扣
        totalModifiersDiscount = (0, precisionMath_1.add)(totalModifiersDiscount, discountValue);
        if (modifier.type === 'DISCOUNT') {
            totalDiscountModifiersDiscount = (0, precisionMath_1.add)(totalDiscountModifiersDiscount, discountValue);
        }
        else {
            totalMerchantModifiersDiscount = (0, precisionMath_1.add)(totalMerchantModifiersDiscount, discountValue);
        }
        // 從可折扣金額中扣除
        total = (0, precisionMath_1.subtract)(total, discountValue);
        // 寫入 modifier 中
        return Object.assign(Object.assign({}, modifier), { calculatedAmount: -discountValue });
    });
    // MR 打印時根據 setTotalIncludeItems 可能會需要不包含 setItems 的 total
    // calculateLocalOrder 計算服務費時，套餐殼和套餐中的餐點各自計算自己的服務費，所以需要不包含 setItems 的 total
    let totalWithoutSetItems = total;
    let totalWithoutSetItemsWithoutDiscountModifiers = (0, precisionMath_1.add)(total, totalDiscountModifiersDiscount);
    // 計算 setItems
    const setItems = item.setItems.map((setItem) => calculateLocalBatchItem(setItem, order));
    // 計入 setItems 價格
    originalTotal = (0, precisionMath_1.add)(originalTotal, lodash_1.default.sumBy(setItems, 'originalTotal'));
    totalMenuDiscount = (0, precisionMath_1.add)(totalMenuDiscount, lodash_1.default.sumBy(setItems, 'totalMenuDiscount'));
    totalModifiersDiscount = (0, precisionMath_1.add)(totalModifiersDiscount, lodash_1.default.sumBy(setItems, 'totalDiscount'));
    totalDiscountModifiersDiscount = (0, precisionMath_1.add)(totalDiscountModifiersDiscount, lodash_1.default.sumBy(setItems, 'totalDiscountModifiersDiscount'));
    totalMerchantModifiersDiscount = (0, precisionMath_1.add)(totalMerchantModifiersDiscount, lodash_1.default.sumBy(setItems, 'totalMerchantModifiersDiscount'));
    total = (0, precisionMath_1.add)(total, lodash_1.default.sumBy(setItems, 'total'));
    // 補欄位
    const prices = lodash_1.default.fill(Array(item.quantity), total);
    const totals = lodash_1.default.fill(Array(item.quantity), total);
    // 計算 quantity
    originalTotal = (0, precisionMath_1.multiply)(originalTotal, item.quantity);
    totalWithoutSetItems = (0, precisionMath_1.multiply)(totalWithoutSetItems, item.quantity);
    totalWithoutSetItemsWithoutDiscountModifiers = (0, precisionMath_1.multiply)(totalWithoutSetItemsWithoutDiscountModifiers, item.quantity);
    totalMenuDiscount = (0, precisionMath_1.multiply)(totalMenuDiscount, item.quantity);
    totalModifiersDiscount = (0, precisionMath_1.multiply)(totalModifiersDiscount, item.quantity);
    totalDiscountModifiersDiscount = (0, precisionMath_1.multiply)(totalDiscountModifiersDiscount, item.quantity);
    totalMerchantModifiersDiscount = (0, precisionMath_1.multiply)(totalMerchantModifiersDiscount, item.quantity);
    total = (0, precisionMath_1.multiply)(total, item.quantity);
    const isDeleted = (item.deletedAt != null && item.deletedAt !== '') || item.cancelled;
    if (order.enableIntermediateRounding) {
        originalTotal = (0, round_1.default)(originalTotal, order.rounding.type, order.rounding.digits);
        totalMenuDiscount = (0, round_1.default)(totalMenuDiscount, order.rounding.type, order.rounding.digits);
        totalModifiersDiscount = (0, round_1.default)(totalModifiersDiscount, order.rounding.type, order.rounding.digits);
        totalDiscountModifiersDiscount = (0, round_1.default)(totalDiscountModifiersDiscount, order.rounding.type, order.rounding.digits);
        totalMerchantModifiersDiscount = (0, round_1.default)(totalMerchantModifiersDiscount, order.rounding.type, order.rounding.digits);
        total = (0, round_1.default)(total, order.rounding.type, order.rounding.digits);
        totalWithoutSetItems = (0, round_1.default)(totalWithoutSetItems, order.rounding.type, order.rounding.digits);
        totalWithoutSetItemsWithoutDiscountModifiers = (0, round_1.default)(totalWithoutSetItemsWithoutDiscountModifiers, order.rounding.type, order.rounding.digits);
    }
    return Object.assign(Object.assign({}, item), { setItems,
        modifiers,
        prices,
        totals,
        priceDeductDiscount, originalTotal: isDeleted ? 0 : (0, fixPrecision_1.default)(originalTotal), totalMenuDiscount: isDeleted ? 0 : (0, fixPrecision_1.default)(totalMenuDiscount), totalDiscountModifiersDiscount: isDeleted ? 0 : (0, fixPrecision_1.default)(totalDiscountModifiersDiscount), totalMerchantModifiersDiscount: isDeleted ? 0 : (0, fixPrecision_1.default)(totalMerchantModifiersDiscount), totalDiscount: isDeleted ? 0 : (0, fixPrecision_1.default)(totalModifiersDiscount), total: isDeleted ? 0 : (0, fixPrecision_1.default)(total), totalWithoutSetItems: isDeleted ? 0 : (0, fixPrecision_1.default)(totalWithoutSetItems), totalWithoutSetItemsWithoutDiscountModifiers: isDeleted ? 0 : (0, fixPrecision_1.default)(totalWithoutSetItemsWithoutDiscountModifiers), totalWithoutDiscountModifiers: isDeleted ? 0 : (0, fixPrecision_1.default)((0, precisionMath_1.add)(total, totalDiscountModifiersDiscount)) });
}
exports.default = calculateLocalBatchItem;
//# sourceMappingURL=calculateLocalBatchItem.js.map